/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import TidalLogo from '../../../../assets/images/promos/tidal/tidal-logo-black.svg';

const PromoTidalReservation = ({ promoCode, onCopyClick, promoUrl, showCopiedMessageClass }) => (
  <div className="c-promo-tidal-reservation">
    <div className="c-promo-tidal-reservation_wrapper">
      <div className="c-promo-tidal-reservation_wrapper_flag">2 Free Months</div>
      <img className="c-promo-tidal-reservation_wrapper_logo" src={TidalLogo} alt="TIDAL" />
      <div className="c-promo-tidal-reservation_wrapper_content">
        <div className="c-promo-tidal-reservation_wrapper_content_code">
          <button
            className="c-promo-tidal-reservation_wrapper_content_code_copy"
            onClick={onCopyClick}
          >
            COPY
          </button>
          <div className="c-promo-tidal-reservation_wrapper_content_code_title">
            TIDAL Redemption Code
          </div>
          <div className="c-promo-tidal-reservation_wrapper_content_code">
            <div
              className={`c-promo-tidal-reservation_wrapper_content_code_copyconfirmation ${showCopiedMessageClass ? 'show' : ''}`}
            >
              promo code has been copied to clipboard
            </div>
            {promoCode}
          </div>
        </div>
        <div className="c-promo-tidal-reservation_wrapper_content_terms">
          This redemption code needs to be applied on the TIDAL subscription page.
        </div>
      </div>
      <a
        className="c-btn c-btn--default"
        href={`${promoUrl}`}
        target="_blank"
      >
        redeem my 2 free months of TIDAL
      </a>
    </div>
    <div className="c-promo-tidal-reservation_terms">
      Not available for current or past TIDAL subscribers must redeem by March 29th 2021. TIDAL Terms & Conditions apply
    </div>
  </div>
);

PromoTidalReservation.propTypes = {
  promoCode: PropTypes.string.isRequired,
  onCopyClick: PropTypes.func.isRequired,
  promoUrl: PropTypes.string.isRequired,
  showCopiedMessageClass: PropTypes.bool.isRequired,
};

export default PromoTidalReservation;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PromoTidalReservation.jsx